"use client";
import { t as cn } from "../chunks/cn-dk9nmc4mhy1765ud.js";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/image/image.tsx
function formatSrcSet(entries) {
	if (entries == null) return void 0;
	if (typeof entries === "string") return entries;
	return entries.map((entry) => {
		if (typeof entry === "string") return entry;
		if ("width" in entry) return `${entry.src} ${entry.width}w`;
		return `${entry.src} ${entry.density}x`;
	}).join(", ");
}
var PICTURE_KEY_SEPARATOR = "|";
var getPictureSrcId = (picture) => [
	formatSrcSet(picture.srcSet),
	picture.type,
	picture.media,
	picture.sizes
].map((value) => value ?? "").join(PICTURE_KEY_SEPARATOR);
/**
* Defaults to `loading="lazy"` and `decoding="async"`.
*/
var Image = React.forwardRef(({ alt, className, srcSet, sources, fallbackSrc, loading = "lazy", decoding = "async", onError, ...props }, ref) => {
	const handleError = React.useCallback((event) => {
		if (fallbackSrc && event.currentTarget.src !== fallbackSrc) {
			event.currentTarget.src = fallbackSrc;
			event.currentTarget.srcset = "";
		}
		onError?.(event);
	}, [fallbackSrc, onError]);
	const errorProps = fallbackSrc || onError ? { onError: handleError } : void 0;
	const img = /* @__PURE__ */ jsx("img", {
		ref,
		alt,
		srcSet: formatSrcSet(srcSet),
		loading,
		decoding,
		className: cn("block max-w-full", className),
		...props,
		...errorProps
	});
	if (!sources || sources.length === 0) return img;
	return /* @__PURE__ */ jsxs("picture", { children: [sources.map((source) => /* @__PURE__ */ jsx("source", {
		srcSet: formatSrcSet(source.srcSet),
		type: source.type,
		media: source.media,
		sizes: source.sizes,
		width: source.width,
		height: source.height
	}, getPictureSrcId(source))), img] });
});
Image.displayName = "Image";
//#endregion
export { Image };

